import { APIRoute } from '@/modules/utils'
import { Review } from '@/dataV3/Review/Review'

export const Route = (): APIRoute => ({
  method: 'POST',
  path: '/v3/reviews/external',
})

export type Body = { content: string; rating: number } & {
  to: string
  email: string
  firstName: string
  lastName: string
  newsletterOptIn: boolean
  authorType: 'BORROWER' | 'PETSITTER' | 'DOGOWNER'
}

export type Response = Review
